import React from "react";
import Select, { GroupBase, OptionProps } from "react-select";
import { Controller } from "react-hook-form";
import ValidationMsgComponent from "../ValidationMsgComponent";
import { Col, Row } from "reactstrap";
import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAdd,} from "@fortawesome/free-solid-svg-icons";
import "./index.css"


interface ControlledSearchProps {
    label?: string;
    inputName: string;
    placeholder?: string;
    invalid?: boolean;
    control: any;
    rules?: object;
    errors?: object;
    isRequired?: boolean;
    hasSideLabel?: boolean;
    sideLabel?: string;
    isDisabled?: boolean;
    defaultValue?: string;
    className?: string;
    optionsList: any;
    isLoading?: boolean;
    isSearchable?: boolean;
    defaultSelectedValue?: any;
    isMulti?: boolean;
    isClear?: boolean;
    value?: any;
    loading?: boolean;
    handleInputChange?: any;
    onChange?: (selectedOption: any) => void;
    components?: Partial<{
        Option: (props: OptionProps<any, boolean, GroupBase<any>>) => JSX.Element;
    }>;
    hasButton?: boolean;
    buttonLabel?: string;
    onButtonClick?: () => void;
}

const ControlledSearch: React.FC<ControlledSearchProps> = ({
    label,
    inputName,
    invalid,
    control,
    rules,
    errors,
    isRequired,
    isMulti,
    isDisabled,
    placeholder,
    isClear,
    components,
    defaultSelectedValue,
    optionsList,
    loading,
    handleInputChange,
    onChange,
    value,
    hasButton,
    buttonLabel,
    onButtonClick,
}) => {
    return (
        <div className="mb-1">
            <Row>
                {label && <Col lg="4">{label && <label htmlFor={inputName}>{label}{isRequired && ' *'}</label>}</Col>}
                <Col
                    lg={label
                        ? hasButton
                            ? 4
                            : 8
                        : hasButton
                            ? 9
                            : 12
                    }
                >
                    <Controller
                        name={inputName}
                        control={control}
                        rules={rules}
                        render={({ field }) => (
                            <Select
                                id={inputName}
                                classNamePrefix="select"
                                options={optionsList}
                                isClearable={isClear}
                                isLoading={loading}
                                isSearchable
                                isMulti={isMulti}
                                isDisabled={isDisabled}
                                defaultValue={defaultSelectedValue}
                                components={components}
                                placeholder={placeholder}
                                onInputChange={handleInputChange}
                                value={field.value || value || null}
                                onChange={(selectedOption) => {
                                    field.onChange(selectedOption);
                                    if (onChange) {
                                        onChange(selectedOption);
                                    }
                                }}
                                required={isRequired}
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                }}
                                menuPortalTarget={document.body}
                            />
                        )}
                    />
                    {invalid && (
                        <ValidationMsgComponent
                            inputName={inputName}
                            invalid={invalid}
                            errors={errors}
                            rules={rules}
                        />
                    )}

                </Col>

                {hasButton && (
                    <Col lg="4" >
                        <Button className="has-button mt-3 mt-lg-0" onClick={onButtonClick}>
                            <FontAwesomeIcon icon={faAdd} color='#ffffff' className="me-2"/>
                            {buttonLabel}
                        </Button>
                    </Col>
                )}
            </Row>
        </div>
    );
};

export default ControlledSearch;
